import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class SilentPrint extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        silentPrint: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func
    };

    render() {
        const {silentPrint, changeDeviceSettings, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-left text-black">
                    <div className="boxBtn-inner">
                      <div className="settiongs-name">
                        <span className="settiongs-name-name">{msg.settings.silentPrint.title}</span>
                        <span className="settiongs-name-info">{msg.settings.silentPrint.subtitle}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                    <div className="switch">
                        <div className={`switch-option text-l ${silentPrint ? 'active' : ''} color-greenLight`}
                             onClick={() => changeDeviceSettings('silentPrint', true)}>
                            <div className="switch-inner">
                                <span>{msg.settings.on}</span>
                            </div>
                        </div>
                        <div className={`switch-option text-l ${silentPrint ? '' : 'active'} color-red`}
                             onClick={() => changeDeviceSettings('silentPrint', false)}>
                            <div className="switch-inner">
                                <span>{msg.settings.off}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    silentPrint: state.device.silentPrint
}), {changeDeviceSettings})(SilentPrint);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/SilentPrint.js